/** Region of the project */
export const REGION = 'southamerica-east1';
